import type { ReactElement } from 'react';
import { Tooltip as AriaTooltip, TooltipTrigger } from 'react-aria-components';

/** Wraps one focusable child; the tip shows on hover and keyboard focus. */
export function Tooltip({ label, children }: { label: string; children: ReactElement }): ReactElement {
  return (
    <TooltipTrigger delay={300}>
      {children}
      <AriaTooltip
        offset={4}
        className="m-0 px-2 py-1 border-0 rounded-control bg-ink text-on-ink-strong font-ui text-sm z-popover"
      >
        {label}
      </AriaTooltip>
    </TooltipTrigger>
  );
}
